import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
  max-width: 39rem;

  & > *:last-child {
    margin: -2rem auto 0;
  }
`;
